const VISIBLE_COUNT = 3;
const LABEL_MORE = "もっと見る";
const LABEL_LESS = "閉じる";

function getCollapsedHeight(list, fadeEl) {
  const cards = [...list.children].slice(0, VISIBLE_COUNT);
  if (cards.length < VISIBLE_COUNT) return null;

  const gap = Number.parseFloat(getComputedStyle(list).rowGap) || 0;
  const fadeHeight = fadeEl?.offsetHeight || 0;
  const fadeCover = fadeHeight + gap;

  const base = cards[0].offsetHeight + gap + cards[1].offsetHeight + gap;
  const thirdVisible = Math.min(cards[2].offsetHeight, fadeCover);

  return base + thirdVisible;
}

export default function initVisionKae10() {
  const root = document.querySelector(".js-vision-kae10");
  if (!root) return;

  const panel = root.querySelector(".pg-vision-kae10__panel");
  const list = root.querySelector(".pg-vision-kae10-list");
  const fade = root.querySelector(".pg-vision-kae10__fade");
  const button = root.querySelector(".js-vision-kae10-toggle");
  const label = root.querySelector(".js-vision-kae10-toggle-text");

  if (!panel || !list || !fade || !button || !label) return;

  const syncCollapsedHeight = () => {
    if (root.classList.contains("is-expanded")) {
      panel.style.maxHeight = "";
      return;
    }

    const height = getCollapsedHeight(list, fade);
    if (height) {
      panel.style.maxHeight = `${height}px`;
    }
  };

  const setExpanded = (expanded) => {
    root.classList.toggle("is-expanded", expanded);
    button.setAttribute("aria-expanded", String(expanded));
    label.textContent = expanded ? LABEL_LESS : LABEL_MORE;

    if (expanded) {
      panel.style.maxHeight = "";
      return;
    }

    syncCollapsedHeight();
  };

  button.addEventListener("click", () => {
    const willExpand = !root.classList.contains("is-expanded");
    setExpanded(willExpand);

    if (!willExpand) {
      button.focus({ preventScroll: true });
      root.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  });

  syncCollapsedHeight();
  window.addEventListener("resize", syncCollapsedHeight);

  if (document.fonts?.ready) {
    document.fonts.ready.then(syncCollapsedHeight);
  }
}
